import { Button, Chevron } from '@lmc/ui-kit'
import { Dropdown } from 'antd'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'

type ReviewLogDropdownButtonProps = {
  hasPermissionToCreateCase: boolean
  hasPermissionToCloseCase: boolean
  onCloseIncidentClick: () => void
  onCreateCaseClick: () => void
}

const ReviewLogDropdownButton = ({
  hasPermissionToCreateCase,
  hasPermissionToCloseCase,
  onCloseIncidentClick,
  onCreateCaseClick
}: ReviewLogDropdownButtonProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Dropdown
      menu={{
        items: [
          ...(hasPermissionToCloseCase
            ? [
                {
                  label: t(incidentReportsConstants.CLOSE_INCIDENT),
                  key: '1',
                  onClick: onCloseIncidentClick
                }
              ]
            : []),

          ...(hasPermissionToCreateCase
            ? [
                {
                  label: t(incidentReportsConstants.CREATE_CASE),
                  key: '2',
                  onClick: onCreateCaseClick
                }
              ]
            : [])
        ]
      }}
      trigger={['click']}
    >
      <Button variant="primary">
        Review
        <Chevron direction="down" />
      </Button>
    </Dropdown>
  )
}

export default ReviewLogDropdownButton
